import styled from '@emotion/styled';

export const EnumSelectContainer = styled.div`
	height: 100%;
	max-height: 4.5rem;
	${(props) => props.viewmode && `overflow: auto;`};

	body[dir='rtl'] & {
		max-height: 5.5rem;
	}
`;

export const EnumSelectWrapper = styled.div`
	display: flex;
	position: relative;
`;

export const IconContainer = styled.span`
	display: flex;
	align-items: center;
`;

export const Label = styled.div`
	display: flex;
	justify-content: space-between;
	flex: 1 1 auto;
	width: 100%;
	height: 100%;
	max-height: 4.5rem;
	min-height: 4.5rem;
	margin: 0;
	font-size: var(--paragraph3-font-size);
	color: var(--black);
	background-color: var(--input-bg-color);
	padding: 0.9rem 1.2rem;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	cursor: pointer;

	> .typography {
		line-height: 1.8;
	}

	:hover,
	:active {
		background-color: var(--table-selected-color);
	}
	:focus,
	&.open {
		border: 1px solid var(--blue) !important;
		background-color: var(--table-selected-color);
		outline: none;
	}
	&.error {
		border: 1px solid var(--red) !important;
		background-color: var(--red-10);
	}
	&.disabled {
		border: 1px solid var(--border-color);
		background-color: var(--input-disabled-bg-color);
		color: var(--input-disabled-bg-color);
		-webkit-text-fill-color: var(--input-disabled-bg-color);
		opacity: 1;
		pointer-events: none;
		cursor: none;

		&.error {
			border: 1px solid var(--red);
		}

		.typography {
			color: var(--content-4);
		}
	}

	body[dir='rtl'] & {
		max-height: 5.5rem;
		min-height: 5.5rem;
	}
`;

export const EnumSelectMultipleButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
	padding: var(--padding-2);
`;

export const EnumSelectContentContainer = styled.div`
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	z-index: var(--z-index-10);
	box-shadow: var(--container-box-shadow);
	max-width: 100vw;

	.search-input {
		margin: var(--margin-2);
	}
`;

export const EnumSelectContentWrapper = styled.div`
	max-height: ${(props) => (props.maxHeight ? `min(24rem, calc(${props.maxHeight}px - 5.5rem))` : '24rem')};
	overflow: auto;
	padding: ${({ searchable }) => (searchable ? '0' : 'var(--padding-2)')} var(--padding-2)
		${({ showMultipleSelectionButtons }) => (showMultipleSelectionButtons ? '0' : 'var(--padding-2)')}
		var(--padding-2);
`;

export const EnumSelectItem = styled.div`
	padding: var(--padding-2) var(--padding-3);
	cursor: pointer;
	border-radius: var(--small-border-radius);

	&:hover {
		background-color: var(--table-selected-color);
	}
`;

export const MultipleSelectionItem = styled.div`
	display: flex;
	align-items: center;
	padding: var(--padding-2);
	border-radius: var(--small-border-radius);
	cursor: pointer;
	gap: var(--padding-2);
	border-inline-start: 2px solid transparent;

	> input {
		flex: 0 0 auto;
		cursor: pointer;
	}

	&:hover {
		background-color: var(--table-selected-color);
	}

	&.selected {
		background-color: var(--table-active-color);
		border-inline-start: 2px solid var(--blue);
		border-radius: 0;
	}
`;

export const EnumSelectNoItems = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 5rem;
`;

export const Loading = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	font-size: 2rem;
`;
